import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { api } from "helpers/api_url";

export interface OrderFlowQuery {
  dateFrom?: Date;
  dateTo?: Date;
  warehouse?: any[];
}

export const fetchOrderFlow = createAsyncThunk(
  "orderFlow/fetchOrderFlow",
  async (query: OrderFlowQuery, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();

      // Add date filters
      if (query.dateFrom) {
        params.append("date_from", query.dateFrom.toISOString().split('T')[0]);
      }
      if (query.dateTo) {
        params.append("date_to", query.dateTo.toISOString().split('T')[0]);
      }

      // Add warehouse filters (exclude "all" option)
      if (query.warehouse && query.warehouse.length > 0) {
        const warehouseIds = query.warehouse
          .map((w: any) => w.warehouse_id)
          .filter((id: any) => id !== "all" && id !== "All Warehouses");
        
        if (warehouseIds.length > 0) {
          if (warehouseIds.length === 1) {
            params.append("warehouse_id", warehouseIds[0].toString());
          } else {
            params.append("warehouse_id", warehouseIds.join(','));
          }
        }
      }

      const url = `${api?.dashboad?.order_flow}${params.toString() ? `?${params.toString()}` : ''}`;
      const response = await Axios.get(url);
      
      if (response.data?.data) {
        return response.data.data;
      }

      // Return default values if data is missing
      return {
        enquiry: { count: 0 },
        quotation: { count: 0, conversion: 0 },
        order: { count: 0, conversion: 0 },
        dispatch: { count: 0, conversion: 0 },
      };
    } catch (err: any) {
      return rejectWithValue(err?.response?.data || "Network Error");
    }
  }
);

